/* Card case builder 3D preview (three.js r128, global THREE): case shell + dividers, card stacks standing in their rows, slabs in
   their slots (clear body + label band), packs as foil stacks, bays outlined, lid open on the hinge. Drag to turn, wheel to zoom. */
(function () {
  'use strict';
  var host = document.querySelector('[data-cc-builder] [data-3d]');
  if (!host) return;
  var R, scene, cam, group, raf = 0, yaw = -0.65, pitch = 0.6, zoom = 1, dist = 600;

  function init() {
    if (!window.THREE) { host.innerHTML = '<p class="ccb-note" style="padding:24px">3D needs a newer browser.</p>'; return false; }
    R = new THREE.WebGLRenderer({antialias: true, alpha: true}); R.setPixelRatio(Math.min(2, window.devicePixelRatio || 1)); host.appendChild(R.domElement);
    scene = new THREE.Scene(); cam = new THREE.PerspectiveCamera(32, 1, 1, 6000);
    scene.add(new THREE.AmbientLight(0xb8bfd8, 0.8)); scene.add(new THREE.HemisphereLight(0xe6e9ff, 0x0b0d12, 0.55));
    var key = new THREE.DirectionalLight(0xffffff, 1.05); key.position.set(320, 620, 380); scene.add(key);
    var rim = new THREE.DirectionalLight(0x9a8cff, 0.6); rim.position.set(-480, 220, -420); scene.add(rim);
    var drag = null;
    R.domElement.addEventListener('pointerdown', function (e) { drag = {x: e.clientX, y: e.clientY, yaw: yaw, pitch: pitch}; R.domElement.setPointerCapture(e.pointerId); });
    R.domElement.addEventListener('pointermove', function (e) { if (!drag) return; yaw = drag.yaw - (e.clientX - drag.x) * 0.008; pitch = Math.max(0.12, Math.min(1.45, drag.pitch + (e.clientY - drag.y) * 0.006)); });
    R.domElement.addEventListener('pointerup', function () { drag = null; });
    R.domElement.addEventListener('wheel', function (e) { e.preventDefault(); zoom = Math.max(0.5, Math.min(2.2, zoom * (e.deltaY > 0 ? 1.08 : 0.92))); }, {passive: false});
    window.addEventListener('resize', size); size(); return true;
  }
  function size() { if (!R) return; var w = host.clientWidth || 360, h = Math.max(260, Math.round(w * 0.78)); R.setSize(w, h); cam.aspect = w / h; cam.updateProjectionMatrix(); }
  function chamfer(w, d, c) {
    var s = new THREE.Shape(), x = w / 2, z = d / 2;
    s.moveTo(-x + c, -z); s.lineTo(x - c, -z); s.lineTo(x, -z + c); s.lineTo(x, z - c); s.lineTo(x - c, z); s.lineTo(-x + c, z); s.lineTo(-x, z - c); s.lineTo(-x, -z + c); s.lineTo(-x + c, -z);
    return s;
  }
  function shell(w, d, h, wall, mat, edge) {
    var g = new THREE.Group(), o = chamfer(w, d, 6), hole = new THREE.Path(), iw = w / 2 - wall, id = d / 2 - wall;
    hole.moveTo(-iw, -id); hole.lineTo(-iw, id); hole.lineTo(iw, id); hole.lineTo(iw, -id); hole.lineTo(-iw, -id); o.holes.push(hole);
    var geo = new THREE.ExtrudeGeometry(o, {depth: h, bevelEnabled: false}); geo.rotateX(-Math.PI / 2);
    g.add(new THREE.Mesh(geo, mat)); g.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo, 30), edge));
    var f = new THREE.Mesh(new THREE.BoxGeometry(w - 2 * wall, 3, d - 2 * wall), mat); f.position.y = 1.5; g.add(f);
    return g;
  }
  function box(w, h, d, mat, x, y, z) { var m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat); m.position.set(x, y, z); return m; }
  function build(P, hex) {
    if (group) { scene.remove(group); group.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); }
    group = new THREE.Group(); scene.add(group);
    if (!P || P.tooBig || P.plate === 'big' || !window.CCB) return;
    var K = window.CCB.K, col = new THREE.Color(hex || '#16181f');
    var body = new THREE.MeshStandardMaterial({color: col, metalness: 0.45, roughness: 0.45});
    var divMat = new THREE.MeshStandardMaterial({color: col.clone().multiplyScalar(0.85), metalness: 0.4, roughness: 0.55});
    var edge = new THREE.LineBasicMaterial({color: 0x9a8cff, transparent: true, opacity: 0.85});
    var cardMat = new THREE.MeshStandardMaterial({color: 0xe8e4f4, metalness: 0.05, roughness: 0.7});
    var cardTop = new THREE.MeshStandardMaterial({color: 0x7aa8ff, metalness: 0.6, roughness: 0.3, emissive: 0x241a55, emissiveIntensity: 0.4});
    var slabMat = new THREE.MeshPhysicalMaterial ? new THREE.MeshPhysicalMaterial({color: 0xf2f6ff, metalness: 0, roughness: 0.05, transparent: true, opacity: 0.6}) : new THREE.MeshStandardMaterial({color: 0xdfe8ff, transparent: true, opacity: 0.45});
    var labelMat = new THREE.MeshStandardMaterial({color: 0xe9ecf4, roughness: 0.5, emissive: 0x2a1f55, emissiveIntensity: 0.25});
    var foil = new THREE.MeshStandardMaterial({color: 0xb68cff, metalness: 0.9, roughness: 0.25});
    var bayMat = new THREE.MeshBasicMaterial({color: 0x9a8cff, transparent: true, opacity: 0.12});
    var Hb = P.Ho - K.lidDepth;
    group.add(shell(P.Wo, P.Do, Hb, K.wall, body, edge));
    var ox = -P.Wi / 2, oz = -P.Di / 2, divH = Math.min(Hb - 4, P.Hin * 0.55);
    P.blocks.forEach(function (b) {
      var x0 = ox + b.x, z0 = oz + b.y;
      if (b.type === 'bay') {
        var hh = Math.min(P.Hin, b.c.bh), g = box(b.w - 8, hh, b.d - 8, bayMat, x0 + b.w / 2, K.floor + hh / 2, z0 + b.d / 2); group.add(g);
        var ge = new THREE.LineSegments(new THREE.EdgesGeometry(g.geometry), edge); ge.position.copy(g.position); group.add(ge);
        // walls of the bay
        group.add(box(b.w, divH, K.divider, divMat, x0 + b.w / 2, divH / 2, z0), box(b.w, divH, K.divider, divMat, x0 + b.w / 2, divH / 2, z0 + b.d));
        return;
      }
      // lane dividers run along the lanes
      for (var l = 0; l <= b.lanes; l++) {
        var off = l * (b.lane + K.divider) + K.divider / 2;
        if (!b.rot) group.add(box(K.divider, divH, b.d, divMat, x0 + off, divH / 2, z0 + b.d / 2));
        else group.add(box(b.w, divH, K.divider, divMat, x0 + b.w / 2, divH / 2, z0 + off));
      }
      for (var ln = 0; ln < b.lanes; ln++) {
        var n = Math.min(b.per, b.q - ln * b.per); if (n <= 0) break;
        var cx = !b.rot ? x0 + K.divider + ln * (b.lane + K.divider) + b.lane / 2 : null;
        var cz = b.rot ? z0 + K.divider + ln * (b.lane + K.divider) + b.lane / 2 : null;
        var hgt = b.c.h, wid = b.c.w;
        if (b.type === 'slabs') {
          for (var k = 0; k < n; k++) {
            var o = K.divider + k * b.pitch + b.c.t / 2;
            var px = !b.rot ? cx : x0 + o, pz = !b.rot ? z0 + o : cz;
            var sw = !b.rot ? wid : b.c.t, sd = !b.rot ? b.c.t : wid;
            group.add(box(sw, hgt, sd, slabMat, px, K.floor + hgt / 2, pz));
            group.add(box(!b.rot ? wid * 0.96 : b.c.t + 0.2, hgt * 0.17, !b.rot ? b.c.t + 0.2 : wid * 0.96, labelMat, px, K.floor + hgt * 0.89, pz));
            group.add(box(!b.rot ? wid * 0.78 : b.c.t * 0.4, hgt * 0.62, !b.rot ? b.c.t * 0.4 : wid * 0.78, cardTop, px, K.floor + hgt * 0.42, pz));
          }
        } else {
          var stack = Math.min(n * b.pitch, b.d - 2 * K.divider - 2);
          var pack = b.c.row && b.c.id === 'pack';
          var sx = !b.rot ? wid : stack, sz = !b.rot ? stack : wid;
          var px2 = !b.rot ? cx : x0 + K.divider + 1 + stack / 2, pz2 = !b.rot ? z0 + K.divider + 1 + stack / 2 : cz;
          group.add(box(sx, hgt, sz, pack ? foil : cardMat, px2, K.floor + hgt / 2, pz2));
          group.add(box(sx * (pack ? 1 : 0.98), 0.8, sz * 0.98, pack ? foil : cardTop, px2, K.floor + hgt + 0.4, pz2));
        }
      }
    });
    var lid = shell(P.Wo, P.Do, K.lidDepth, K.wall, new THREE.MeshStandardMaterial({color: col, metalness: 0.45, roughness: 0.45, transparent: true, opacity: 0.9}), edge);
    lid.rotation.x = Math.PI;
    var pivot = new THREE.Group(); pivot.position.set(0, Hb, -P.Do / 2); group.add(pivot);
    lid.position.set(0, 0, P.Do / 2); pivot.add(lid); pivot.rotation.x = -Math.PI * 0.6;
    dist = Math.max(P.Wo, P.Do, P.Ho * 1.6) * 2.3;
  }
  function frame() {
    raf = requestAnimationFrame(frame);
    if (host.hidden || !R) return;
    var d = dist * zoom;
    cam.position.set(Math.sin(yaw) * Math.cos(pitch) * d, Math.sin(pitch) * d + 30, Math.cos(yaw) * Math.cos(pitch) * d); cam.lookAt(0, 40, 0);
    R.render(scene, cam);
  }
  window.CC3D = {
    show: function (P, c) { if (!R && !init()) return; size(); build(P, c); if (!raf) frame(); },
    update: function (P, c) { if (R && !host.hidden) build(P, c); }
  };
})();
